import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setFieldName: YJSChangeHandler<DatabaseChangeType.SET_FIELD_NAME> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    if (field) {
      field.applyNameDelta(change.delta);
    }
  });
};
